import React from 'react';
import {
  VehicleLineupSection,
  PopularCoursesSection,
  AdditionalOptionsSection
} from '../organisms';

const VehicleLineupDemo = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* VIP車両ラインナップ */}
      <VehicleLineupSection type="vip" />

      {/* 人気コース */}
      <PopularCoursesSection />

      {/* 追加オプション */}
      <AdditionalOptionsSection />

      {/* バス車両ラインナップ */}
      <VehicleLineupSection type="bus" className="bg-white" />
    </div>
  );
};

export default VehicleLineupDemo;
